import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';

@Injectable()
export class BrandInterceptor implements HttpInterceptor {
    constructor(private readonly store: Store) {}
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        const brand = this.store.snapshot().auth.brand;
        if (brand) {
            const reqCopy = req.clone({
                headers: req.headers.set('Brand', this.getBrandId(brand.id)),
            });
            return next.handle(reqCopy);
        } else {
            return next.handle(req);
        }
    }

    private getBrandId(brandId: number): string {
        // Hotfix for Mozambique (backend working with 154, but in production it's 152)
        if (brandId === 152) {
            return '154';
        }
        return String(brandId);
    }
}
